import {
  type ChangeEvent,
  type FocusEvent,
  type KeyboardEvent,
  memo,
  type RefObject,
} from "react";

import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type OtpDigitProps = {
  index: number;
  digit: string;
  valueLength: number;
  onChange: (e: ChangeEvent<HTMLInputElement>, idx: number) => void;
  onKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
  onFocus: (e: FocusEvent<HTMLInputElement>) => void;
  firstInputRef?: RefObject<HTMLInputElement | null>;
  withLightBg?: boolean;
};

export const OtpDigitBase = ({
  index,
  digit,
  valueLength,
  onChange,
  onKeyDown,
  onFocus,
  firstInputRef,
  withLightBg,
}: OtpDigitProps) => (
  <input
    aria-label={`otp-input-${index}`}
    autoComplete="one-time-code"
    className={cnTwMerge(
      "w-full h-[84px] p-0 text-center heading-4 rounded-companyBorderRadius border-border/primary focus:border-brand-default focus:ring-0 focus:ring-offset-0 hover:border-brand-default",
      withLightBg ? "bg-background/component" : "bg-dark-gray",
    )}
    data-testid={`otp-input-${index}`}
    inputMode="numeric"
    key={`otp-input-${index}`}
    maxLength={valueLength}
    onChange={(e) => onChange(e, index)}
    onFocus={onFocus}
    onKeyDown={onKeyDown}
    pattern="\d{1}"
    ref={index === 0 ? firstInputRef : undefined}
    type="text"
    value={digit}
  />
);

export const OtpDigit = memo(OtpDigitBase);
